import { useTranslation } from "react-i18next";
import { AppIconButton } from "../../../../../../../../shared/components/AppIconButton";
import { TrashIcon } from "../../../../../../../../shared/icons/TrashIcon";
import { LongArrowIcon } from "../../../../../../../../shared/icons/LongArrowIcon";
import {
  TSkill,
  TSkills,
} from "../../../../../../../../services/api/instances/skillsApi/types";
import styles from "./styles.module.css";
import { GenericAutocomplete } from "../../../../../../../../common/GenericAutocomplete";

interface Props {
  skills: TSkills;
  skill: TSkill | null;
  addSkills: TSkills | null;
  onSelectSkill: (skill: TSkill | null, id: string) => void;
  onDeleteSkill: (id: string) => void;
}

export const SkillsTool = (props: Props) => {
  const { t } = useTranslation();
  const filteredSkills = props.skills.filter((skill) => {
    const isUsedByOtherTool = props.addSkills?.some((tool) => {
      if (tool.name === props.skill?.name) {
        return false;
      }
      return tool.name === skill.name;
    });

    if (isUsedByOtherTool) {
      return false;
    }

    return true;
  });

  return (
    <div className={styles["container"]}>
      <div className={styles.wrapper}>
        <GenericAutocomplete<TSkill>
          options={filteredSkills}
          value={props.skill}
          onChange={(newSkill) =>
            props.onSelectSkill(newSkill, props.skill?.id ?? "")
          }
          getLabel={(skill) => skill.friendly_name}
          getValue={(skill) => skill.name}
          getOptionKey={(skill) => skill.id}
          autocompleteStyle={"select"}
          emptyOptionLabel={t("agents.select_skill_placeholder")}
          className={styles["autocomplete"]}
        />
        <AppIconButton
          onClick={() => props.onDeleteSkill(props.skill?.id ?? "")}
          className={styles["delete-btn"]}
        >
          <TrashIcon width={24} height={24} />
        </AppIconButton>
      </div>
      <LongArrowIcon />
      <div className={styles["description-container"]}>
        {props.skill?.description}
      </div>
    </div>
  );
};
